module.exports = __webpack_public_path__ + "img/resource-tech-image-20.704f4ecd.jpg";